<template>
  <b-row>
    <b-col class="d-flex flex-row-reverse">
      <Save size="sm" variant="primary" type="submit" @savebtn="$emit('save')" :label="label" :tabindex="tabsave"
        v-if="savehide" :loading="loading" :disabled="disabled" />
      <Cancel @canclebtn="goback()" v-if="cancelhide" :tabindex="tabcancel" :btnname="CancelLabel" />
      <Save type="submit" @savebtn="" label="Send Test Message" v-if="TestMessage" :tabindex="tabMsg"
        :loading="loading" />
    </b-col>
  </b-row>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from "vue";
import Save from "../GeneralButtons/SaveButton.vue";
import Cancel from "../GeneralButtons/CancelButtton.vue";
import { useRoute, useRouter } from "vue-router";
import { setupHistoryManagement } from "../../modules/Inventory/Service/HistoryManage";

export default defineComponent({
  components: {
    Save,
    Cancel,
  },
  props: {
    goback: {
      type: Function as PropType<(() => void) | undefined>,
      required: false,
    },
    TestMessage: {
      type: Boolean,
      default: false,
    },
    cancelhide: {
      type: Boolean,
      default: true,
    },
    savehide: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: "Save",
    },
    CancelLabel: {
      type: String,
      default: "Cancel",
    },
    tabsave: {
      type: Number,
    },
    tabcancel: {
      type: Number,
    },
    tabMsg: {
      type: Number,
    },
    path: {
      type: String,
      required: false,
    },
    flag: {
      type: Number,
      default: 2,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const callHeader = ref(false);
    const goback = () => {
      debugger;
      if (props.goback!) {
        setupHistoryManagement(router, props.flag);
        //props.goback()
      } else {
        if (props.path) {
          router.push(props.path!);
        }
      }
      emit("cancel");
      emit("clickclear");
    };

    return {
      goback,
      // setupHistoryManagement
    };
  },
});
</script>

<style lang="scss" scoped></style>
